import { createSlice } from "@reduxjs/toolkit";
import { getAllLookupData } from "../thunks/lookup";

const initState = {
  loading: true,
  data: [],
  error: null,
};

const lookupSlice = createSlice({
  name: "lookupSlice",
  initialState: initState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // To rertieve all lookup data
      .addCase(getAllLookupData.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllLookupData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getAllLookupData.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default lookupSlice;
